import { TypeDefinition } from "../generic";

interface Type extends TypeDefinition {
    code: string;
}

export class FDCompensationTypes {
    public static EQ: Type = { id: 1, code: "EQ", name: "Equipment (dept or practice)" };
    public static G: Type = { id: 2, code: "G", name: "Grants" };
    public static H: Type = { id: 3, code: "H", name: "Honoraria" };
    public static IP: Type = { id: 4, code: "IP", name: "Intellectual Property Rights" };
    public static NC: Type = { id: 5, code: "NC", name: "No Compensation Received" };
    public static OB: Type = { id: 6, code: "OB", name: "Other Financial Benefit" };
    public static R: Type = { id: 7, code: "R", name: "Royalty" };
    public static RF: Type = { id: 8, code: "RF", name: "Residency or Fellowship Program Funding" };
    public static S: Type = { id: 9, code: "S", name: "Salary" };
    public static ST: Type = { id: 10, code: "ST", name: "Stock" };
    public static SO: Type = { id: 11, code: "SO", name: "Stock Options" };

    public static Values: Type[] = [
        FDCompensationTypes.EQ,
        FDCompensationTypes.G,
        FDCompensationTypes.H,
        FDCompensationTypes.IP,
        FDCompensationTypes.NC,
        FDCompensationTypes.OB,
        FDCompensationTypes.R,
        FDCompensationTypes.RF,
        FDCompensationTypes.S,
        FDCompensationTypes.ST,
        FDCompensationTypes.SO,
    ];
}



// WEBPACK FOOTER //
// ./src/models/financialDisclosure/FDCompensationTypes.ts